<template>
    <div class="map-detail">
        <div class="search content-container">
            <div class="go-black">返回</div>
            <div class="search-right">
                <el-select class="map-select" v-model="value" placeholder="请选择城市">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="map-select" v-model="value" placeholder="请选择区域">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="map-select" v-model="value" placeholder="请选择建筑">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="map-select" v-model="value" placeholder="请选择大学">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="map-select" v-model="value" placeholder="居室">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="map-select" v-model="value" placeholder="建筑类型">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select class="map-select" v-model="value" placeholder="距离">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div class="map-box">
            <div id="map" class="detail-map"></div>
        </div>
    </div>
</template>
<script>
import mapboxgl from "mapbox-gl";
export default {
    components: {

    },
    data(){
        return {
            value:'',
            options:[{value:'lalal',label:'llll'}]
        }
    },
    mounted(){
        this.setMap()
    },
    methods:{
        setMap(){
            let center = [-2.2402536,53.4641521]
            mapboxgl.accessToken =
            "pk.eyJ1IjoidXppbGl2aW5nIiwiYSI6ImNqemhzbmdxMTB5Y3MzZHBpazN1N3d2cTkifQ.3-_OtVv-450QSH1sNu2mGA";
            var map = new mapboxgl.Map({
                container: "map",
                style: "mapbox://styles/mapbox/streets-v11?optimize=true",
                center: center,
                pitch: 60,
                bearing: -60,
                zoom: 12,
            });
            new mapboxgl.Popup({ closeButton:false,offset: 25})
                .setLngLat(center)
                .setHTML('<h1>'+ +'</h1>')
                .addTo(map);
            new mapboxgl.Marker().setLngLat(center).addTo(map);
        },
    }
}
</script>
<style lang="scss" scoped>
.map-detail{
    width: 100%;
    height: 100%;
    background: #fafafa;
}
.search{
    height: 10rem;
    display: flex;
    padding-top: 2.4rem;
}
.search-right{
    margin-left: 3rem;
    width: 50rem;
    display: flex;
    flex-wrap: wrap;
}
.map-select{
    margin-right: 2rem;
}
.go-black{
    width: 6rem;
    height: 2rem;
    border:1px solid #e6e6e6;
    text-align: center;
    line-height: 1.8rem;
    background: #fff;
    font-size: 0.7rem;
    color: #a3a0a0;
}
.detail-map{
    width: 100%;
    height: calc(100vh - 10rem);
}
</style>